import React from 'react'
import styles from './styles.module.scss'
import { first, second, third, logo, edu_prog } from '../../assets/img/dashCategoris'
import { NavLink } from 'react-router-dom'
import { arrowRight } from '../../assets/svg/dashboard/main'


const CATEGORIES = [
  { name: 'Показатели деятельности', link: '/dashboard_new/ciup', img: first },
  { name: 'Аккредитационные показатели', link: '/dashboard_new/accreditation',  img: second },
  { name: 'Соответствие образовательных программ требованиям', link: '/dashboard_new/edu_prog', img: edu_prog },
]

const Main = () => {
  
  
  const renderCategory = ({ name, link, img }) => (
    <li className={styles.card} key={name}>
      <NavLink to={link}>
        <div>
          <p>{name}</p>
          <div>{arrowRight}</div>
        </div>
      <img src={img} alt={name} />
      </NavLink>
    </li>
  )
  
  
  return (
    <div className={styles.mainWrap}>
      <ul>{CATEGORIES.map(renderCategory)}</ul>
    </div>
  )
}

export default Main